import React from 'react';
import { Monitor } from 'lucide-react';

const SystemSettings: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="rounded-2xl bg-gradient-to-br from-gray-700 to-gray-900 p-3">
          <Monitor className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">System Settings</h1>
          <p className="text-gray-600">Configure system-wide preferences and defaults</p>
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
        <p className="text-gray-600">System settings content will be implemented here.</p>
      </div>
    </div>
  );
};

export default SystemSettings;
